import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { WidgetCard, WidgetCardHeader } from "../../../ProjectLayout/ui/WidgetCard";

type THomeWidgetProps = {
  title: ReactNode;
  actions?: ReactNode;
  bodyClassName?: string;
  children: ReactNode;
};

export function HomeWidget({ title, actions, bodyClassName, children }: THomeWidgetProps) {
  return (
    <WidgetCard data-slot="home-widget">
      <WidgetCardHeader title={title} titleOverflow="wrap" actions={actions} className="flex-nowrap gap-y-3" />
      <div className={cn("flex flex-col gap-4 p-5", bodyClassName)}>{children}</div>
    </WidgetCard>
  );
}
